import type { IAddressAdapter } from "@/domains/address/adapters/address-adapter.ts";
import type { TGovernmentNormalizedAddress } from "@/domains/address/dto/normalized-address.ts";
import type { TGeocodedAddressDto } from "@/types/backoffice/dto/site/site-dto.ts";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode } from "@/domains/country/country.types.ts";

import { gouvFeatureToAddressSuggestion } from "../providers/french-government/french-government-address-provider";

export const FrenchGovernmentNormalizedAddressToBackofficeAddress: IAddressAdapter<
  TGovernmentNormalizedAddress,
  TGeocodedAddressDto
> = {
  adapt(address: TGovernmentNormalizedAddress): TGeocodedAddressDto {
    const suggestion = gouvFeatureToAddressSuggestion(address.raw);

    return {
      externId: suggestion.id,
      geocoding: {
        latitude: suggestion.latitude,
        longitude: suggestion.longitude,
      },
      zipCode: suggestion.postalCode,
      city: suggestion.city,
      cityCode: suggestion.cityCode,
      administrativeDivision: suggestion.administrativeDivisions,
      country: {
        label: ECountry.FRANCE,
        isoCode: ECountryCode.FRANCE,
      },
      inseeCode: suggestion.cityCode,
      provider: EAddressProvider.FRENCH_GOVERNMENT,
      score: suggestion.score,
      label: suggestion.label,
      street: suggestion.street,
      streetNumber: suggestion.streetNumber,
    };
  },
};
